import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import MiddahContent from "../../components/Pages/Middot";

const { displayName } = config;

export default function Middot(): React.ReactNode | null {
  useEffect(() => {
    document.title = `${displayName}: Middot`;
  }, []);

  return (
    <Layout title="Middot List">
      <MiddahContent />
    </Layout>
  );
}
